import React, { useState, useEffect, useRef } from 'react';
import './UpDownNum.css';

function UpDownNum({device, setDeviceValue, value, displayFunc, active, amount}) {
	const [localValue, setLocalValue] = useState(value);
	const debounceTimer = useRef(null);

	// Sync with server state, but only if we are not waiting for a debounce timer.
	// This prevents server state from overwriting optimistic updates.
	useEffect(() => {
		if (!debounceTimer.current) {
			setLocalValue(value);
		}
	}, [value]);

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	const handleClick = (newValue) => {
		setLocalValue(newValue);

		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			setDeviceValue(device.serial, newValue);
			debounceTimer.current = null;
		}, 1000);
	};

	return (
		<div className='updownnum'>
			<div className='left'>
				<button onClick={() => handleClick(localValue - amount)} disabled={!active}>➖</button>
			</div>

			<div className='middle'>
				{displayFunc(localValue)}
			</div>

			<div className='right'>
				<button onClick={() => handleClick(localValue + amount)} disabled={!active}>➕</button>
			</div>
		</div>
	);
}

export default UpDownNum;
